import SidebarInstance from '@js/modules/public/rankings/institutional/view/components/sidebar';
import {
    toggleRankingFilters,
} from '@js/modules/public/rankings/institutional/view/components/sidebarFilters';
import {initSelectsWithLiveSearch, refreshRankingPage} from '@js/modules/public/rankings/institutional/view/helpers';
import {appendQueryParam, getUrlParameter, reloadWithoutGetParams, replaceUrlParam} from '@js/helpers/location';
import {switchTab} from "@js/helpers/tabSwitcher";
import {initScrollRankingPage} from "@js/components/ranking/scrollRankingPage";
import {initMultipleSelectFilterListener} from "@js/modules/public/accreditations/index/filtersHandle";

$(() => {
    const sidebar = new SidebarInstance('#sidebar_inner');
    initRankingFiltersListeners();
    initSelectsWithLiveSearch();
    initScrollRankingPage();

    const urlAnchor = location.hash;
    if (urlAnchor !== '') {
        switchTab(urlAnchor);
    }

    $('body')
        .on('click', '.sorting-column', function () {
            const $column = $(this);
            let queryParams = $('form.ranking-filters').serialize();
            const sortingColumn = $column.attr('data-sorting-column');
            const isActiveSortingColumn = $column.hasClass('sorting-column--active');
            let sortingType = $column.closest('table').attr('data-sorting-type');
            if (isActiveSortingColumn) {
                sortingType = sortingType === 'asc' ? 'desc' : 'asc';
            }
            queryParams = appendQueryParam(queryParams, 'sort_by', sortingColumn);
            queryParams = appendQueryParam(queryParams, 'sort_type', sortingType);
            refreshPageWithParams(queryParams);
        })
        .on('shown.bs.tab', 'a[data-toggle="tab"]', (e) => {
            document.location.hash = $(e.target).attr("href");
            window.scrollTo(0, 0);
        });
    $('.applied-filters')
        .on('click', '.remove-all-applied-filters', reloadWithoutGetParams)
        .on('click', '.remove-applied-filter', function () {
            const isMultiple = $(this).data('multiple') === true;
            const filterName = $(this).data('filter');
            let replacementValue;
            if (isMultiple) {
                const multipleFilterValue = $(this).data('multiple-value');
                const urlParamValues = getUrlParameter(filterName);
                replacementValue = urlParamValues.filter((item) => {
                    return item != multipleFilterValue;
                });
            } else {
                replacementValue = '';
            }
            window.location.search = replaceUrlParam(filterName, replacementValue);
        });
});

function refreshPageWithParams(queryParams) {
    window.location.search = queryParams;
}

function initRankingFiltersListeners() {
    const $multipleSelects = $('select.multiple-select');
    $multipleSelects.selectpicker({
        noneSelectedText: 'Все'
    });
    initMultipleSelectFilterListener($multipleSelects);
    const $singleSelects = $('.ranking-filters select').not($('#modal-filter-form select'))
        .not($multipleSelects);
    $singleSelects
        .on('change', refreshRankingPage);
    const $modalFiltersForm = $('#modal-filter-form');

    $modalFiltersForm
        .on('click', '#btnFilter', () => {
            refreshRankingPage(false);
        });

    $('body')
        .on('click', '.show-ranking-filters', toggleRankingFilters);
}
